import styled from 'styled-components';

export const Block = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  overflow-x: clip;
  background: ${(props) => props.theme.colors.themeBackground};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  width: 100%;
  max-width: 1366px;
  margin: 0 auto;
  padding: 0 15px;

  @media ${(props) => props.theme.breakpoints.desktop} {
    padding: 0 50px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-grow: 1;
  align-self: center;
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
